import styled from 'styled-components';
import PrimaryButton from '@carvana/showroom-forms/Button/Primary';

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1em 3em 3em 3em;
  background-color: ${(props) => props.theme.color.neutral.v100};
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
`;

const AutopayScheduleDetailsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  padding: 1em 0;
  background-color: ${(props) => props.theme.color.neutral.v100};
  font-weight: 700;
  font-size: 28px;
  line-height: 32px;
  width: 100%;
`;

const AutopayScheduleDetailsColumnWrapper = styled.div`
  flex-direction: column;
  text-align: center;
  width: 50%;
  margin: 0;
`;

const AutopayScheduleLabel = styled.div`
  color: ${(props) => props.theme.color.neutral.v500};
  font-size: 18px;
  font-weight: normal;
  line-height: 28px;
`;

const AutopayScheduleMsg = styled.div`
  color: ${(props) => props.theme.color.primary.v600};
  font-size: 18px;
  font-weight: normal;
  line-height: 28px;
  padding-bottom: 10px;
  text-align: center;
`;

const AutopayScheduleReminder = styled.div`
  color: ${(props) => props.theme.color.neutral.v500};
  font-size: 16px;
  font-weight: normal;
  line-height: 24px;
  text-align: center;
`;

const DuoCheckmark = styled.img`
  margin: 20px 0 10px;
  width: 50px;
  height: 50px;
`;

const CloseButton = styled(PrimaryButton)`
  padding: 0;
  width: 100%;
  min-height: 56px;
  font-size: 14px;
  margin-top: 26px;

  @media (min-width: ${(props) => props.theme.breakpoint.sm}px) {
    width: 250px;
    text-align: center;
  }
`;

const HR = styled.hr`
  font-weight: normal;
  color: ${(props) => props.theme.color.neutral.v200};
  margin: 0;
  opacity: 0.5;
  border-bottom-color: transparent;
`;

export {
  ModalContent,
  AutopayScheduleDetailsWrapper,
  AutopayScheduleLabel,
  AutopayScheduleMsg,
  AutopayScheduleReminder,
  AutopayScheduleDetailsColumnWrapper,
  DuoCheckmark,
  CloseButton,
  HR,
};
